import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Panel,
          Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          ControlLabel,
          Table,
          Checkbox,
          Glyphicon,
          Modal,
          ButtonGroup,
          DropdownButton,
          MenuItem,
          Tooltip,
          OverlayTrigger,
          Image,} from "react-bootstrap";
import Truncate from 'react-truncate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from 'react-16-bootstrap-date-picker';//has min/maxDate but no time
import Datetime from 'react-datetime';//has time but no min/maxDate
import {ToastContainer, ToastStore} from 'react-toasts';
import GoogleMapReact from 'google-map-react';
import UsersService from "../../services/users-service";
import ToursService from "../../services/tours-service";

// import MapMaker from './mapMaker.js'

import _ from "underscore";
import $ from "jquery";
import moment from 'moment';
var map;
//props
//facilities
class TourMap extends Component {

  constructor(props, context) {
      super(props, context);

      this.state = {
        client: null,
        facilityMap: { location: { lat: 8.189470, lng: 124.023140}},
        colors: ["red", "blue", "orange", "pink", "green", "violet", "forestgreen", "gainsboro", "darkgreen", "lavenderblush"],
        personnelList: [],
                    // [{id:"1", name: "Ernesto", visible: true, location: {lat: 8.189470, lng: 124.023140}},
                    //     {id: "2", name: "Louis", visible: true, location: {lat: 8.189571, lng: 124.0232}},
                    //     {id: "3", name: "Pete", visible: true, location: {lat: 8.189381, lng: 124.02351}},
                    //     {id: "4", name: "Vrogross", visible: true, location: {lat: 8.189541, lng: 124.02325}},
                    //     {id: "5", name: "Raigor", visible: true, location: {lat: 8.189491, lng: 124.02335}},
                    //     {id: "6", name: "Sven", visible: true, location: {lat: 8.189391, lng: 124.02295}},
                    //     {id: "7", name: "Sam", visible: true},
                    //     {id: "8", name: "Dean", visible: true},],
        locations: [],
                    // [{id:"1", name: "Vault", visible: true, location: {lat: 8.189380, lng: 124.023280}},
                    // {id: "2", name: "Gate 1", visible: true, location: {lat: 8.189361, lng: 124.02382}},
                    // {id: "3", name: "Gate 2", visible: true, location: {lat: 8.189451, lng: 124.02281}}],
        facility: null,
        showLocationLabels: true,
        showBreadcrumbHistory: false,
        time: "",
      }

      this.renderMap = this.renderMap.bind(this);
  }

  render() {
    return <Col style={{padding: 30, minHeight: 700, marginTop: 10, marginBottom: 30, marginLeft: 10, marginRight: 10}}>
              {this.renderFilters()}
              {this.renderMap()}
              {this.renderPersonnelList()}
          </Col>;
  }

  renderFilters() {
    var facilities = this.props.facilities ? this.props.facilities : [];
    return (<div style={{flexDirection: "row", borderBottom: "thin solid #000000"}}>
              <Col>
                <Row>
                  <Col className="col-md-2" style={{fontSize: 20, color: "#20404B", textAlign: "left"}}>Filters</Col>
                  <Col className="col-md-2 pull-right" style={{fontSize: 15, color: "#20404B", textAlign: "left", textDecorationLine: 'underline' ,cursor: 'pointer'}}
                            onClick={()=>{
                              this.setState({
                                              facility: "",
                                              showLocationLabels: false,
                                              showBreadcrumbHistory: false,
                                              time: ""})
                                            }}>Clear Filters</Col>
                </Row>
                <Row>

                  <FormGroup controlId="facility" className="col-md-3"
                                          style={{textAlign: "center", padding: 5, borderRadius: 5, marginLeft: 30}}>
                          <ControlLabel className="login_label">Facility</ControlLabel>
                          <FormControl  componentClass="select" placeholder="Facility"
                                        style={{width: "100%"}}
                                        value={this.state.facility ? this.state.facility.facility_id : ""}
                                        onChange={(e)=>{
                                            var newFacility = _.find(this.props.facilities, (facility)=>{
                                              return facility.facility_id === e.target.value
                                            });
                                            var newPersonnelList = [];//Needs api
                                            ToursService.sharedInstance.getFacilityLocationsByFacilityId(e.target.value)
                                                        .then((response)=>{
                                                          this.setState({
                                                              facility: newFacility,
                                                              personnelList: newPersonnelList,
                                                              locations: response,
                                                              })
                                                        });


                                        }}>
                                        {facilities.length > 0
                                              ? <option disabled value={""}>Select Facility</option>
                                              : <option disabled value={""}>No Options</option> }
                                        {facilities.map((choice, index)=>{
                                              if(choice.is_active === "1") {
                                                return <option key={index} value={choice.facility_id}>{choice.facility_name}</option>
                                              }
                                          })
                                        }
                          </FormControl>
                  </FormGroup>

                  <FormGroup controlId="location" className="col-md-3 "
                                          style={{textAlign: "center", paddingTop: 30, borderRadius: 5}}>
                          <Checkbox  type="checkbox"
                            checked={this.state.showLocationLabels}
                            onChange={(e)=>{
                              this.setState({showLocationLabels: !this.state.showLocationLabels});
                            }}>
                              Location Labels
                            </Checkbox>
                  </FormGroup>

                  <FormGroup controlId="breadCrumb" className="col-md-3 "
                                            style={{textAlign: "center", paddingTop: 30, borderRadius: 5}}>
                              <Checkbox  type="checkbox"
                                checked={this.state.showBreadcrumbHistory}
                                onChange={(e)=>{
                                  ToastStore.warning("Breadcrumbs currently in Progress!")
                                  this.setState({showBreadcrumbHistory: !this.state.showBreadcrumbHistory});
                                }}>
                                  Breadcrumb History
                              </Checkbox>
                  </FormGroup>

                  <FormGroup controlId="Time" className="col-md-2"
                                          style={{textAlign: "center", padding: 5, borderRadius: 5}}>
                                          <ControlLabel className="login_label">Time</ControlLabel>
                                          <Datetime
                                            dateFormat={false}
                                            value={this.state.time}
                                            onChange={(e)=>{
                                              this.setState({time: e})}}/>
                                          </FormGroup>

                </Row>
              </Col>
           </div>);
  }

  renderMap() {

      var mapOptions = (maps) =>{
        return {
                  mapTypeControl: true,
                  mapTypeId: maps.MapTypeId.SATELLITE,
                }
      }
      var facility = this.state.facility;
      var latitude = facility ? parseFloat(facility.latitude) : 8.189470;
      var longitude = facility ? parseFloat(facility.longitude) : 124.023140;
      var center = facility ? {lat: latitude != 0 ? latitude : 8.189470, lng: longitude != 0 ? longitude : 124.023140} : { lat: 8.189470, lng: 124.023140};
      return <div style={{ height: '70vh', width: '100%' }}>
              {facility
                  ? <GoogleMapReact
                        options={mapOptions}
                        bootstrapURLKeys={{ key: "AIzaSyDC_uFHUc5D6KXs5Ng1iVJsbJsQZvRpz6k" }}
                        defaultCenter={{ lat: 8.189470, lng: 124.023140}}
                        center={center}
                        defaultZoom={18}>

                        {this.renderPersonnelInMap()}
                        {this.renderLocationsInMap()}

                  </GoogleMapReact>
                : <div><center style={{paddingTop: "10%"}}>Select a Facility to show its map here.</center></div>}
            </div>
  }

  renderPersonnelList() {

    var colors = this.state.colors;
    return <Row style={{height: 280, padding: 30, marginBottom: 50}}>
              <h2 style={{color: "orange", textAlign: "left"}}> Personnel</h2>
              <ul style={{height: "250px",
                          width: 250 * (this.state.personnelList.length/6),
                          display: "flex",
                          flexDirection: "column",
                          flexWrap: "wrap"}}>
              {this.state.personnelList.map((personnel, i)=>{
                            var colorIndex = i;

                            while(colorIndex > colors.length - 1) {
                              colorIndex -= colors.length - 1;
                            }
                           return (<li key={i} className="pull-left">
                                       <Checkbox
                                         className="pull-left"
                                         checked={personnel.visible}
                                         onChange={()=>{
                                           var newPersonnelList = this.state.personnelList.slice();
                                           var newPersonnel = JSON.parse(JSON.stringify(personnel));
                                           newPersonnel.visible = !newPersonnel.visible;
                                           newPersonnelList.splice(i, 1,newPersonnel);
                                           this.setState({
                                             personnelList: newPersonnelList,
                                           });
                                       }}>
                                         <b style={{color: colors[colorIndex]}}>{personnel.name}</b>
                                       </Checkbox>
                                   </li>);
                         })}
                         </ul>
          </Row>
  }

  renderPersonnelInMap() {
    var colors = this.state.colors;
    return this.state.personnelList.map((personnel, i)=>{

      if(personnel != null && personnel.visible) {
        var colorIndex = i;

        while(colorIndex > colors.length - 1) {
          colorIndex -= colors.length - 1;
        }

        return <div
                    key={i}
                    lat={personnel.latitude}
                    lng={personnel.longitude}>
                    <div style={{justifyContent: "center"}}>
                    {
                      //<Row style={{ borderRadius: 30, backgroundColor: "white", padding: 3, minWidth: 150}}><b>{personnel.name}</b></Row>
                    }
                    <Row>
                      <Glyphicon className="pull-center" glyph="map-marker"
                        style={{marginRight: 15, color: colors[colorIndex], fontSize: 40}}
                        onClick={()=>{}}/>
                    </Row>
                    </div>


                </div>
      }
    })
  }

  renderLocationsInMap() {
    var colors = this.state.colors;
    var locations = [];

    if(this.state.locations) {
      this.state.locations.map((location, i)=>{
        if(this.state.showLocationLabels
                    && parseFloat(location.latitude) != 0 && parseFloat(location.longitude) != 0) {

          var width = location.location_name.length * 15;

          locations.push(<div
                      key={i}
                      lat={location.latitude}
                      lng={location.longitude}
                      style={{justifyContent: "flex-start", position: "absolute",minWidth: width, left: "-"+width * 0.5+"px"}}>
                        <Row style={{textAlign: "center"}}>
                            <b style={{ borderRadius: 5, padding: 15, backgroundColor: "white", width: "auto", fontSize: 12}}>{location.location_name}</b>
                          <Row>
                            <Glyphicon className="pull-center" glyph="triangle-bottom"
                              style={{color: "white", fontSize: 40}}
                              onClick={()=>{}}/>
                          </Row>
                        </Row>


                  </div>)
        }
      })
    }

    return locations;
  }


}

export default TourMap;
